
function setActiveContentTab(contentTabs, activeId = 0){
    const contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    const contentTabsContent = contentTabs.querySelector('.contentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        const contents = contentTabsContent.children;
        const contentHeaderChildren = contentTabsHeader.children;

        if(contents){
            let count = 0;
            for(const contentHeaderTab of contentHeaderChildren){
                contentHeaderTab.classList.remove("is-active");
                if(count === activeId){
                    contentHeaderTab.classList.add("is-active");
                }
                count++;
            }
            count = 0;
            for(const content of contents){
                content.classList.remove("is-active");
                if(count === activeId){
                    content.classList.add("is-active");
                }
                count++;
            }
        }
    }
}

function buildContentTabs(contentTabs){
    const contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    const contentTabsContent = contentTabs.querySelector('.contentTabs__content');

    if(contentTabsHeader && contentTabsContent){
        const contents = contentTabsContent.children;

        if(contents){
            for(const content of contents){
                content.classList.add("contentTabs__contentItem");
            }
        }
    }

    contentTabs.classList.add("initialized");
}

function getCurrentIndex(tabs,currentTab){
    let index = 0;

    for(const tab of tabs){
        if(tab === currentTab){
            return index;
        }
        index++;
    }
}

function setEventListenerForTab(contentTabs){
    const contentTabsHeader = contentTabs.querySelector('.contentTabs__header');
    if(contentTabsHeader){
        const contentHeaderChildren = contentTabsHeader.children;

        if(contentHeaderChildren){
            for(const tab of contentHeaderChildren){
                tab.addEventListener("click",function (){
                    setActiveContentTab(contentTabs,getCurrentIndex(contentHeaderChildren,tab));
                });
            }
        }
    }
}

export function initContentTabs(wrapper = document){
    for(const contentTabs of wrapper.querySelectorAll('.contentTabs')){
        buildContentTabs(contentTabs);
        setActiveContentTab(contentTabs);
        setEventListenerForTab(contentTabs);
    }
}